import React, { useState, ReactNode } from 'react'
import PropTypes from 'prop-types'
import Notification from '../notification'
import { InputContainer } from './elements'
import { ReactComponent as Hide } from './icons/hide.svg'
import { ReactComponent as Show } from './icons/show.svg'

interface InputSelectProps {
    sm?: Boolean
    min?: number
    max?: number
    name?: string
    type?: string
    error?: string
    title?: string
    large?: Boolean
    value?: string | number
    select?: Boolean
    options?: Array<any>
    disabled?: Boolean
    textArea?: Boolean
    onChange?: (e: any) => void
    onKeyDown?: (e: any) => void
    labellink?: string
    placeholder?: string
    borderless?: string
    children?: ReactNode
    style?: Object
    success?: string
    className?: string
    reverse?: Boolean
    textAreaProps?: Object
    inputProps?: Object
    inputPattern?: string
    dataCy?: string
    autoComplete?: string
}

const Input = ({
    sm,
    min,
    max,
    name,
    type,
    error,
    title,
    large,
    value,
    select,
    options,
    disabled,
    textArea,
    onChange,
    onKeyDown,
    autoComplete,
    labellink,
    placeholder,
    borderless,
    children,
    style,
    success,
    className,
    reverse,
    textAreaProps = {},
    inputProps = {},
    inputPattern,
    dataCy,
}: InputSelectProps) => {
    const [state, setState] = useState({
        show: false,
        type: 'password',
    })
    const isPassword = type === 'password'
    const refinedType = isPassword ? state.type : type
    const onShow = () => {
        state.show
            ? setState({
                  show: false,
                  type: 'password',
              })
            : setState({
                  show: true,
                  type: 'text',
              })
    }

    return (
        <InputContainer
            reverse={reverse}
            isPassword={isPassword}
            borderless={borderless}
            large={large}
            style={style}
            sm={sm}
            error={error}
            success={success}
            className={className}
            disabled={disabled}
        >
            {title && (
                <label>
                    {title}
                    {labellink && labellink}
                </label>
            )}
            {select ? (
                <select
                    onChange={onChange}
                    name={name}
                    value={value}
                    disabled={Boolean(disabled)}
                >
                    {options?.map((val) => (
                        <option key={val.key || val} value={val.value || val}>
                            {val.option || val}
                        </option>
                    ))}
                </select>
            ) : textArea ? (
                <textarea
                    value={value}
                    disabled={Boolean(disabled)}
                    placeholder={placeholder}
                    onChange={onChange}
                    name={name}
                    {...textAreaProps}
                />
            ) : (
                <input
                    maxLength={max}
                    minLength={min}
                    disabled={Boolean(disabled)}
                    value={value}
                    type={refinedType}
                    placeholder={placeholder}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    name={name}
                    data-cy={dataCy}
                    pattern={inputPattern}
                    autoComplete={autoComplete}
                    {...inputProps}
                />
            )}
            {isPassword && (
                <span className="show-icon" onClick={onShow}>
                    {state.show ? <Hide /> : <Show />}
                </span>
            )}
            {children}
            <Notification errormessage={error} />
            <Notification successmessage={success} />
        </InputContainer>
    )
}

Input.propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    error: PropTypes.any,
    title: PropTypes.string,
    value: PropTypes.string.isRequired,
    textArea: PropTypes.bool,
    onChange: PropTypes.func,
    onKeyDown: PropTypes.func,
    placeholder: PropTypes.string,
    options: PropTypes.array,
    select: PropTypes.bool,
    disabled: PropTypes.bool,
}

Input.defaultProps = {
    error: '',
    options: [],
    select: false,
    disabled: false,
}
export default Input
